import { FORTA_GRAY3 } from '../../../utils/colors';

import type { SxProps, Theme } from '@mui/material';
import type { QuestionnaireSectionLabelProps } from './types';

// Card chrome around each questionnaire page's content. The padding / border /
// radius come in only on md+, so on mobile the page renders flush without the box.
export const QUESTIONNAIRE_PAGE_BOX_SX = {
  p: { xs: 0, md: 2 },
  border: { xs: 'none', md: `1px solid ${FORTA_GRAY3}` },
  borderRadius: { xs: 0, md: '10px' },
};

// Keep the footer navigation buttons a consistent fixed size so Previous / Next
// (and the terminal action) line up regardless of their label length.
export const QUESTIONNAIRE_FOOTER_BUTTON_SX = {
  height: 40,
  width: 110,
} as const;

export const INTRODUCTION_PAGE_SX: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  minHeight: 0,
  width: '100%',
  mx: 'auto',
  ...QUESTIONNAIRE_PAGE_BOX_SX,
};

// Grow into remaining space and center the video frame on both axes.
export const INTRODUCTION_VIDEO_WRAPPER_SX: SxProps<Theme> = {
  display: 'flex',
  flexGrow: 1,
  alignItems: 'center',
  justifyContent: 'center',
};

// Responsive 16:9 frame that fills the column but never grows past half the viewport.
export const INTRODUCTION_VIDEO_CONTAINER_SX: SxProps<Theme> = {
  width: 'min(100%, 70vw)',
  aspectRatio: '16 / 9',
  borderRadius: '10px',
  overflow: 'hidden',
  '--media-border-radius': '10px',
};

export const getQuestionnaireSectionLabelSx = (
  fontWeight: QuestionnaireSectionLabelProps['fontWeight'],
  sx: QuestionnaireSectionLabelProps['sx'],
): SxProps<Theme> => {
  const baseSx = { textAlign: 'left', fontWeight: fontWeight ?? 'bold' } as const;
  if (sx == null) return baseSx;
  return [baseSx, ...(Array.isArray(sx) ? sx : [sx])];
};
